<ng-template>
    <div id="menu" class="menu-wrapper"
         [@height]="closed ? 'closed' : 'opened'"
         [@opacity]="closed ? 'hidden' : 'visible'">
        <div class="menu-container">
            <div class="menu-item-wrapper">
                <ng-content #portal></ng-content>
            </div>
        </div>
    </div>
</ng-template>
